import baseAPI from '@/api';
import { Restriction } from '@/models/restriction';
import { CreateRestrictionRequestDto } from '@/services/dto/restrictions/create-restriction-input.dto';

export async function fetchCreateRestriction(
  data: CreateRestrictionRequestDto,
) {
  const response = await baseAPI.post<Restriction>('/restrictions', data);
  return response.data;
}
